import { motion } from 'framer-motion';
import { Bot, User } from 'lucide-react';

export default function ChatMessage({ role, content }) {
  const isAi = role === 'ai';

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`flex gap-3 ${isAi ? '' : 'flex-row-reverse'}`}
    >
      <div
        className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
          isAi ? 'bg-purple-100 text-purple-600' : 'bg-blue-100 text-blue-600'
        }`}
      >
        {isAi ? <Bot size={18} /> : <User size={18} />}
      </div>
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-3 ${
          isAi
            ? 'bg-gray-100 text-gray-800'
            : 'bg-purple-600 text-white'
        }`}
      >
        <p className="whitespace-pre-wrap text-sm">{content}</p>
      </div>
    </motion.div>
  );
}
